import Rating from '@mui/material/Rating';
import { IFieldProps } from '../fields/InputField';
import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

const RatingField = ({ field, onChange, isReadOnly }: IFieldProps) => {
    const [rating, setRating] = useState<number | null>(null);

    useEffect(() => {
        if (!field.values.length) return;
        const fieldRating = Number(field.values[0].value);
        if (isNaN(fieldRating)) return;

        setRating(fieldRating);
    }, [])

    useEffect(() => {
        if (!rating || isReadOnly) return;
        onChange && onChange([{ id: 0, value: rating.toString() }])
    }, [rating])

    return (
        <Box sx={{ width: "100%" }}>
            <Box marginBottom={1} >
                <Typography display="inline">{field.text.trim()}</Typography>
                {field.required && <Typography display="inline" color="error"> *</Typography>}
            </Box>
            <Rating
                name="simple-controlled"
                value={rating}
                disabled={isReadOnly}
                onChange={(event, newValue) => {
                    setRating(newValue);
                }}
            />

        </Box>
    )



}

export default RatingField;